export default __webpack_public_path__ + "static/media/garantia.bc2d0711.png";